import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Input } from "@/components/ui/input";
import { http, setToken, errorText } from "@/lib/api";
import { IMG } from "@/lib/images";

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setErr("");
    try {
      const { data } = await http.post("/auth/login", { email, password });
      setToken(data.token);
      nav("/admin");
    } catch (e2) {
      setErr(errorText(e2));
    }
    setBusy(false);
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2" data-testid="admin-login-page">
      <img src={IMG.tools} alt="" className="hidden lg:block w-full h-screen object-cover" />
      <div className="flex items-center justify-center p-8">
        <form onSubmit={submit} className="w-full max-w-sm space-y-5" data-testid="admin-login-form">
          <p className="font-serif-display text-4xl">SømSignature</p>
          <p className="eyebrow">Admin-panel</p>
          <Input type="email" required placeholder="E-post" value={email} onChange={(e) => setEmail(e.target.value)} className="rounded-none h-12" data-testid="admin-login-email" />
          <Input type="password" required placeholder="Passord" value={password} onChange={(e) => setPassword(e.target.value)} className="rounded-none h-12" data-testid="admin-login-password" />
          {err && <p className="text-sm text-red-700" data-testid="admin-login-error">{err}</p>}
          <button disabled={busy} className="w-full py-4 bg-[#1A1A1A] text-[#FDFBF7] text-sm hover:bg-[#8C6E48] transition-colors disabled:opacity-50" data-testid="admin-login-submit">{busy ? "Logger inn…" : "Logg inn"}</button>
        </form>
      </div>
    </div>
  );
}
